import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-154" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-155" data-mp="3fze45yusr5w7">
        <h2 className="text-center font-display text-[1.2rem] font-bold uppercase leading-tight text-navy sm:text-[1.7rem]" data-id="element-156" data-mp="3fy2z7vpm7s3i">
          WHAT LEARNERS ARE SAYING
        </h2>
        <div className="mt-2 space-y-2" data-id="element-157" data-mp="36z964fbhtjup">
          {testimonials.map(t => <figure key={t.name} className="rounded-md border border-navy/10 border-l-4 border-l-clinical bg-mist px-2.5 py-2" data-id="element-158" data-mp="3205ziqfv75km">
              <div className="flex gap-0.5 text-gold" role="img" aria-label="5 out of 5 stars" data-id="element-159" data-mp="2x1upofpkkv2e">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-160" data-mp="v9g9bl2obyo3" data-mpi={i} />)}
              </div>
              <p className="mt-1 font-display text-[0.95rem] font-bold leading-tight text-navy sm:text-[1.1rem]" data-id="element-161" data-mp="qa3mv1fpstm1">
                “{t.headline}”
              </p>
              <blockquote className="mt-0.5 text-[0.78rem] leading-[1.4] sm:text-[0.9rem]" data-id="element-162" data-mp="m51cxwwuzfaj">“{t.quote}”</blockquote>
              <figcaption className="mt-1.5 text-[0.7rem] leading-tight sm:text-[0.8rem]" data-id="element-163" data-mp="780n5yy89uep">
                <span className="font-heading font-extrabold text-navy" data-id="element-164" data-mp="c6llttxu0611">{t.name}</span>
                <span className="text-ink/70" data-id="element-165" data-mp="c8oiuxxeizf9">
                  {' '}
                  — {t.role} · {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}